import React, { useContext } from "react";
import LockIcon from "../../../../components/SVGComponents/LockIcon";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import userContext from "../../../../context/users/UserContext";
import { t } from "i18next";
import themeContext from "../../../../context/theme/ThemeContext";
import { Icon, Spinner, SpinnerSize } from "@fluentui/react";
import { REPORTDONESTATUS, USERTYPES } from "../../../../constants/Constants";

const LockWarning = (props) => {

  const { roles, username, authenticated, loadByUsername, userId, qcReviewer } =
  useContext(userContext);

  const { getAlterColor } = useContext(themeContext);

  const {
    showLockWarning,
    lockStudy,
    showLockButton,
    alreadyLocked,
    setShowReturnStudyModal,
    reportDoneStatusState,
    hideLockWarningMessage,
    lockedByOther,
    autoSaveReportPreference,
    reportAutosaveStatus,
    reportAutosaveDirty,
    reportAutosaveLastSavedAt,
    snapshotRecoveryReopenVisible,
    handleSnapshotRecoveryReopen,
    reportAutosaveBlocked,
    patientReports,
    disableSave,
  } = useContext(studyReportContext);

  const isRadiologist = roles[0] === USERTYPES.RADIOLOGIST;
  const isTypist = roles[0] === USERTYPES.TYPIST;
  const isDraftEditableStatus =
    reportDoneStatusState === REPORTDONESTATUS.UNREPORTED ||
    reportDoneStatusState === REPORTDONESTATUS.SAVED ||
    reportDoneStatusState === REPORTDONESTATUS.DRAFT;
  const isAssignedDraftEditor =
    (isRadiologist && alreadyLocked) || (isTypist && !disableSave);

  const isSnapshotRecoveryOptionVisible =
    snapshotRecoveryReopenVisible &&
    isDraftEditableStatus &&
    isAssignedDraftEditor;

  const isAutoSaveVisible =
    (autoSaveReportPreference &&
      isDraftEditableStatus &&
      isAssignedDraftEditor &&
      !reportAutosaveBlocked) ||
    isSnapshotRecoveryOptionVisible;

  const renderAutoSaveState = () => {
    if (!isAutoSaveVisible){
      return null;
    }

    const hasReportTemplate = (patientReports?.length ?? 0) > 0;
    
    if (snapshotRecoveryReopenVisible) {
      return (
        <span
          onClick={handleSnapshotRecoveryReopen}
          style={{ display: "inline-flex", alignItems: "center", gap: "6px", cursor: "pointer" }}
        >
          <Icon iconName="Save" style={{ color: "#0078d4", fontSize: "14px" }} />
          <span>Draft available</span>
        </span>
      );
    }

    if (reportAutosaveStatus === "saving") {
      return (
        <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
          <span>Auto save:</span>
          <Spinner size={SpinnerSize.xSmall} />
          <span>Saving draft</span>
        </span>
      );
    }

    if (!hasReportTemplate) {
      return (
        <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
          <span>Auto save:</span>
          <Icon
            iconName="SkypeCircleCheck"
            style={{ color: "#107c10", fontSize: "14px" }}
          />
          <span>On</span>
        </span>
      );
    }

    if (
      reportAutosaveDirty &&
      (reportAutosaveStatus === "on" || reportAutosaveStatus === "saved")
    ) {
      return (
        <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
          <span>Auto save:</span>
          <Icon iconName="Save" style={{ color: "#d29200", fontSize: "14px" }} />
          <span>Unsaved changes</span>
        </span>
      );
    }

    if (reportAutosaveStatus === "saved") {
      return (
        <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
          <span>Auto save:</span>
          <Icon iconName="SkypeCircleCheck" style={{ color: "#107c10", fontSize: "14px" }} />
          <span>Draft saved</span>
        </span>
      );
    }

    return (
      <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
        <span>Auto save:</span>
        <Icon
          iconName={reportAutosaveLastSavedAt ? "CompletedSolid" : "SkypeCircleCheck"}
          style={{ color: "#107c10", fontSize: "14px" }}
        />
        <span>{reportAutosaveLastSavedAt ? "Draft saved" : "On"}</span>
      </span>
    );
  };
  const lockWarningJustify = !isAutoSaveVisible
    ? "center"
    : isRadiologist
      ? "space-between"
      : "flex-end";

  // const {assignmentData} = useContext(studyviewerContext);
  return (<>
     <div className="lock-warning-section" style={{ position: "relative", display: "flex", justifyContent: lockWarningJustify, paddingInlineStart: "22px", paddingInlineEnd: "11px"}}>
      {isRadiologist && !alreadyLocked && <p style={{color: getAlterColor("#FFE144","#0078D4"),visibility:(showLockWarning && !hideLockWarningMessage)?"visible":"hidden"}} className="lock-warning-text no-margin">
        {lockedByOther?t("string-literals.not-locked-study"):t("string-literals.not-allowed-submit-report")} &nbsp;
      </p>
      }
      {isRadiologist && alreadyLocked && <p style={{color: getAlterColor("#7af156","#0078D4")}} className="unlock-warning-text no-margin">
        This study is locked {(reportDoneStatusState == 2 && reportDoneStatusState != null)?" and submitted":""} by you. &nbsp;
      </p>}
      <div>
        {renderAutoSaveState()}
      </div>
    </div></>
  );
};

export default LockWarning;
